const locale = {
  service: {
    name: "Servicio",
    list: {
      badge: "Servicio",
    },
    tabs: {
      product: "Producto",
      service: "Servicio",
    },
    breadcrumb: {
      createPath: "Crear servicio",
      editPath: "Editar servicio",
      editProfessionals: "Profesionales",
    },
    form: {
      nameLabel: "Nombre del servicio",
      nameError: "El nombre del servicio es obligatorio",
    },
    detail: {
      title: "Detalle",
    },
    information: {
      title: "Información del servicio",
    },
    config: {
      title: "Configuración del servicio",
    },
    mapContent: {
      detailLabel: "Detalle",
      informationLabel: "Información",
      configLabel: "Configuración",
    },
    duration: {
      title: "Duración del servicio",
      customLabel: "Duración personalizada",
      scheduleInfo:
        "Los horarios de atención de tu tienda se configuran desde la app móvil de Domun.",
      scheduleCardText:
        "Configura los horarios de atención de tu tienda para que tus clientes puedan reservar servicios.",
      configureSchedule: "Configurar horarios",
      editSchedule: "Editar horarios de tienda",
      options: {
        one: "1 Hr.",
        two: "2 Hr.",
        three: "3 Hr.",
        other: "Personalizado",
        none: "",
      },
    },
    professionals: {
      title: "Profesionales",
      add: "Agregar",
      edit: "Editar",
      empty: "Aún no has agregado profesionales a este servicio.",
      editorTitle: "Profesionales del servicio",
      editorDescription:
        "Agrega los profesionales que pueden realizar este servicio.",
      namePlaceholder: "Nombre del profesional",
      enabled: "Activo",
      remove: "Eliminar",
      addRow: "Agregar profesional",
    },
  },
  product: {
    name: "Producto",
    breadcrumb: {
      createPath: "Crear producto",
      editPath: "Editar producto",
      editPhotos: "Editar fotos",
      editFeatures: "Editar características",
      editStock: "Editar stock"
    },
    mapContent: {
      detailLabel: "Detalle",
      inventoryLabel: "Inventario",
      productInfoLabel: "Información del producto",
    },
    productDetail: {
      title: "Detalle"
    },
    uploadImage: {
      principalTag: "Principal",
    },
    photoAi: {
      cta: "Foto IA",
      referenceTitle: "Elige una foto de referencia",
      referenceConfirm: "Continuar",
      resultsTitle: "Imágenes sugeridas",
      resultsDescription: "Selecciona las imágenes que quieres agregar al producto.",
      add: "Agregar",
      adding: "Agregando...",
      loading: "Buscando imágenes similares...",
      cancel: "Cancelar",
      acquireTitle: "Activa Foto IA",
      acquireDescription:
        "Encuentra imágenes similares y mejora las fotos de tus productos.",
      acquireCta: "Adquirir complemento",
      error: "No se pudieron obtener imágenes similares",
      noSlots: "Alcanzaste el límite de fotos de este producto",
      addSuccess: "Imágenes agregadas",
      addError: "No se pudieron agregar las imágenes",
    },
    editImage: {
      title: "Editar fotos",
      description: "Arrastra y suelta las fotos para cambiar el orden"
    },
    productInventory: {
      title: "Inventario"
    },
    productInformation: {
      title: "Información del producto"
    },
    productFeatures: {
      stock: {
        title: "Stock"
      },
      featureForm: {
        title: "Características",
        featureNameLabel: "Característica",
        optionsLabel: "Opciones",
        addLink: "Agregar otra característica"
      }
    }
  },
};

export default locale;
